"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageProcessingNode = void 0;
const core_1 = require("@openhps/core");
class ImageProcessingNode extends core_1.ProcessingNode {
    constructor(options) {
        super(options);
    }
    process(frame) {
        return new Promise((resolve, reject) => {
            if (frame.image) {
                this.processImage(frame.image, frame)
                    .then((image) => {
                    frame.image = image;
                    resolve(frame);
                })
                    .catch(reject);
            }
            else {
                resolve(frame);
            }
        });
    }
}
exports.ImageProcessingNode = ImageProcessingNode;
//# sourceMappingURL=ImageProcessingNode.js.map